export const nutritionGoalsData = [
  {
    id: 1,
    name: 'Very Low Carbohydrate / Ketogenic Diet',
    description:
      'The carbohydrate content of the actual serving is multiplied by the foods GI, then that number is divided by 100. a GL higher than 20 is considered high, between 11 and 19 is considered moderate, and 10 or less is considered low.',
    sortOrder: 1, // will be used for sorting
    isCore: true, // this will be true for all the Nutrition Goals that are shared across Evolve Organizations
    organizationId: null, // this will be used to identify organization specific Nutrition Goals
    programId: null, // this will be used to identify program specific Nutrition Goals
    patientId: null, // this will be used to identify patient created Custom Nutrition Goals
    referenceId: null, // this will be used for versioning the same way we do for assessments and recommendations
    savedAt: '2021-06-19:35:00.000Z', // the date and time when the Goal was last saved at
    publishedAt: '2021-06-16T20:00:00.000Z', // the date and time when the Goal was last published at
    isArchived: false, // whether this an archived version of a Goal
    archivedAt: null, // when was the goal archived
    canPublish: false,
    rules: [
      {
        title: 'Calories',
        equation: 'Custom', // the equation to use for calorie amounts
        male: {
          total: 2000,
          mild: {
            amount: 1750,
            measurement: 'Percent',
          },
          moderate: {
            amount: 1500,
            measurement: 'Percent',
          },
          major: {
            amount: 1250,
            measurement: 'Calories',
          },
        },
        female: {
          total: 1550,
          mild: {
            amount: 1300,
            measurement: 'Percent',
          },
          moderate: {
            amount: 1000,
            measurement: 'Percent',
          },
          major: {
            amount: 750,
            measurement: 'Calories',
          },
        },
      },
      {
        title: 'Protein',
        measurement: 'Percentage',
        operator: 'Less Than',
        value: 250,
      },
      {
        title: 'Fat',
        measurement: 'Grams',
        operator: 'Equals',
        value: 350,
      },
      {
        title: 'Carbs',
        measurement: 'None',
      },
      {
        title: 'Sodium',
        measurement: 'Grams',
        operator: 'Between',
        minValue: 400,
        maxValue: 500,
      },
    ],
  },
  {
    id: 2,
    name: 'Low Carbohydrate',
    description:
      'Add another serving of vegetables to one of your meals each day. Try a new recipe for roasted veggies, cook up some dark leafy greens or sign up for a CSA veggie box in the spring.',
    sortOrder: 2, // will be used for sorting
    isCore: true, // this will be true for all the Nutrition Goals that are shared across Evolve Organizations
    organizationId: null, // this will be used to identify organization specific Nutrition Goals
    programId: null, // this will be used to identify program specific Nutrition Goals
    patientId: null, // this will be used to identify patient created Custom Nutrition Goals
    referenceId: null, // this will be used for versioning the same way we do for assessments and recommendations
    savedAt: '2021-06-19:35:00.000Z', // the date and time when the Goal was last saved at
    publishedAt: '2021-06-16T20:00:00.000Z', // the date and time when the Goal was last published at
    isArchived: false, // whether this an archived version of a Goal
    archivedAt: null, // when was the goal archived
    canPublish: false,
    rules: [
      {
        title: 'Calories',
        equation: 'Mifflin St. Jeor', // the equation to use for calorie amounts
        male: {
          total: 20000,
          mild: {
            amount: 1750,
            measurement: 'Percent',
          },
          moderate: {
            amount: 1500,
            measurement: 'Percent',
          },
          major: {
            amount: 1250,
            measurement: 'Calories',
          },
        },
        female: {
          total: 1500,
          mild: {
            amount: 1250,
            measurement: 'Percent',
          },
          moderate: {
            amount: 1000,
            measurement: 'Percent',
          },
          major: {
            amount: 750,
            measurement: 'Calories',
          },
        },
      },
      {
        title: 'Protein',
        measurement: 'Percentage',
        operator: 'Less Than',
        value: 150,
      },
      {
        title: 'Fat',
        measurement: 'Grams',
        operator: 'Equals',
        value: 50,
      },
      {
        title: 'Carbs',
        measurement: 'Grams',
        operator: 'Equals',
        value: 80,
      },
      {
        title: 'Sodium',
        measurement: 'Grams',
        operator: 'Between',
        minValue: 200,
        maxValue: 300,
      },
    ],
  },
];
